<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="'農業氣象站'" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">

            <!-- 農業氣象站 -->
            <div class="agri-result-group pwa pb-1">
                <b-container fluid class="pb-3">
                    <!-- 標題 -->  
                    <PwaTitle :textTitle="title" :showMore="false"></PwaTitle>
                    <div class="w3-row">
                        <!-- 種類 -->
                        <div class="w3-col w3-container m4 l4">
                            <label class="global-descript">{{ input.type.text }}</label>
                            <v-select class="global-descript" v-model="input.type.value" :options="input.type.list" label="text" :reduce="option => option.text" />
                        </div>
                        <!-- 作物 -->
                        <div class="w3-col w3-container m4 l4">
                            <label class="global-descript">{{ input.crop.text }}</label>
                            <v-select class="global-descript" v-model="input.crop.value" :options="filteredCropList" :reduce="option => option.text" label="text"></v-select>
                        </div>
                    </div>

                    <!-- 標題 -->  
                    <PwaTitle textTitle="溫度事件警示燈號" :showMore="false"></PwaTitle>
                    <!-- 備註 --> 
                    <div class="global-descript container" style="margin-bottom:10px;">備註 : 本產品為研究階段之模式預報資料，僅因應農業所需，暫提供溫度及定量降雨機率預報相關參考資訊。 目前官方預報產品尚無8-14天資訊，且預報仍有不確定性，應隨時更新，請謹慎參考使用。</div>
                    <!-- 簡述 --> 
                    <div class="global-descript container" style="margin-bottom:10px;">最後更新時間：{{ second_week.obj.update_time }}</div>
                    <!-- 燈號 --> 
                    <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                        <table class="global-descript">
                            <tbody>
                            <tr class="warning_light_row time_row" style="">
                                <td class="row_value">&nbsp;</td>
                                <td class="row_value" style="min-width: 70px;">警示日期</td>
                                <td class="row_value" v-for="(value, key) in second_week.list.date_t" :value="value.value" :key="'type' + key" >{{ value.text }}</td>
                            </tr>
                            <tr class="warning_light_row" warning_type="最低溫" style="">
                                <td class="row_value" style="min-width: 60px;">{{ second_week.input.min_t.text }}</td>
                                <td class="row_value">
                                <select class="select-style warning_temp_option" v-model="second_week.input.min_t.value">
                                    <option v-for="(value, key) in second_week.input.min_t.list" :value="value.value" :key="'type' + key" >{{ value.text }}</option>
                                </select>
                                </td>
                                <td class="row_value" v-for="(value, key) in second_week.list.min_t" :value="value.value" :key="'type' + key" >
                                <span class="dot" :class="value.value"></span>
                                </td>
                            </tr>
                            <tr class="warning_light_row" warning_type="最高溫" style="">
                                <td class="row_value">{{ second_week.input.max_t.text }}</td>
                                <td class="row_value">
                                <select class="select-style warning_temp_option" v-model="second_week.input.max_t.value">
                                    <option v-for="(value, key) in second_week.input.max_t.list" :value="value.value" :key="'type' + key" >{{ value.text }}</option>
                                </select>
                                </td>
                                <td class="row_value" v-for="(value, key) in second_week.list.max_t" :value="value.value" :key="'type' + key" >
                                <span class="dot" :class="value.value"></span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- 燈號備註 --> 
                    <div class="global-descript container" style="margin-bottom:10px;">
                        <div data-v-5872cf6d="" id="warning_light_remarks" style="font-size: 14px;">警示燈號備註：<br data-v-5872cf6d="">
                            <span data-v-5872cf6d="" class="dot probability_null"></span> 表示資料尚未更新。<br data-v-5872cf6d="">
                            <span data-v-5872cf6d="" class="dot probability_low"></span> 表示事件發生機率低。<br data-v-5872cf6d="">
                            <span data-v-5872cf6d="" class="dot probability_medium"></span> 表示事件當日發生機率小，但合併評估前後一日<br data-v-5872cf6d=""><span data-v-5872cf6d="" class="dot probability_medium" style="visibility: hidden;"></span> 內，有發生機率。<br data-v-5872cf6d="">
                            <span data-v-5872cf6d="" class="dot probability_high"></span> 表示事件發生機率高。 </div>
                    </div>
                    
                    
                    <!-- 標題 -->  
                    <PwaTitle textTitle="連續5日不降雨機率預報" :showMore="false"></PwaTitle>
                    <!-- 簡述 --> 
                    <div class="global-descript container">最後更新時間：{{ next_week.chart.norain_ratio.update_time }}</div>
                    <!-- 圖表 -->
                    <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                        <div id="chart_next_week2"></div>
                    </div> 
                    <!-- 備註 -->  
                    <p class="global-descript">
                        <span>備註 : </span><br />
                        <span>1. 氣象預報具有不確定性，參考使用應滾動更新。</span><br />
                        <span>2. 本產品為因應農業需求，以模式預報經過偏差矯正與降尺度後之客製化預報產品。</span><br />
                    </p>

                </b-container>
            </div> 

            
        </div>


    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}               
    },  
    components: {
        Header,
        PwaTitle
    },
    data(){
        return {

            title:"",
            token:"",
            level:"",
            station_id:"",
            input:{
                type:{
                    text:"種類",
                    value:"雜糧類",
                    list:[
                        {text:"雜糧類"},
                        {text:"蔬菜類"},
                        {text:"水果類"},
                        {text:"其他"}
                    ]
                },
                crop:{
                    text:"作物",
                    value:"",
                    list:[
                        { "text": "落花生", "type": "雜糧類", "min": "15", "max": "36" },
                        { "text": "玉米", "type": "雜糧類", "min": "21", "max": "27" },
                        { "text": "大蒜", "type": "蔬菜類", "min": "15", "max": "27" },
                        { "text": "甘藷", "type": "雜糧類", "min": "20", "max": "30" },
                        { "text": "竹筍", "type": "蔬菜類", "min": "25", "max": "30" },
                        { "text": "小白菜", "type": "蔬菜類", "min": "6", "max": "40" },
                        { "text": "洋菇", "type": "蔬菜類", "min": "20", "max": "30" },
                        { "text": "萵苣", "type": "蔬菜類", "min": "10", "max": "35" },
                        { "text": "甘藍", "type": "蔬菜類", "min": "15", "max": "21" },
                        { "text": "青蔥", "type": "蔬菜類", "min": "15", "max": "30" },
                        { "text": "甜橙", "type": "水果類", "min": "24", "max": "34" },
                        { "text": "菠菜", "type": "蔬菜類", "min": "15", "max": "20" },
                        { "text": "馬鈴薯", "type": "蔬菜類", "min": "18", "max": "22" },
                        { "text": "芥藍", "type": "蔬菜類", "min": "15", "max": "20" },
                        { "text": "毛豆", "type": "蔬菜類", "min": "22", "max": "32" },
                        { "text": "油菜", "type": "蔬菜類", "min": "20", "max": "25" },
                        { "text": "蕹菜", "type": "蔬菜類", "min": "20", "max": "30" },
                        { "text": "青花苔", "type": "蔬菜類", "min": "22", "max": "25" },
                        { "text": "檳榔", "type": "其他", "min": "24", "max": "28" },
                        { "text": "西瓜", "type": "水果類", "min": "15", "max": "40" },
                        { "text": "香蕉", "type": "水果類", "min": "24", "max": "32" },
                        { "text": "胡蘿蔔", "type": "蔬菜類", "min": "20", "max": "25" },
                        { "text": "南瓜", "type": "雜糧類", "min": "18", "max": "30" },
                        { "text": "芹菜", "type": "蔬菜類", "min": "18", "max": "20" },
                        { "text": "鳳梨", "type": "水果類", "min": "14", "max": "32" },
                        { "text": "蘿蔔", "type": "蔬菜類", "min": "10", "max": "25" },
                        { "text": "結球白菜", "type": "蔬菜類", "min": "18", "max": "22" },
                        { "text": "莧菜", "type": "蔬菜類", "min": "20", "max": "30" },
                        { "text": "洋蔥", "type": "蔬菜類", "min": "20", "max": "25" },
                        { "text": "蕃茄", "type": "水果類", "min": "10", "max": "32" },
                        { "text": "大芥菜", "type": "蔬菜類", "min": "16", "max": "23" },
                        { "text": "椪柑", "type": "水果類", "min": "24", "max": "34" },
                        { "text": "茂谷柑", "type": "水果類", "min": "24", "max": "34" },
                        { "text": "番石榴", "type": "水果類", "min": "15", "max": "32" },
                        { "text": "茼蒿", "type": "蔬菜類", "min": "15", "max": "20" },
                        { "text": "甜椒", "type": "蔬菜類", "min": "20", "max": "30" },
                        { "text": "胡瓜", "type": "蔬菜類", "min": "20", "max": "30" },
                        { "text": "洋香瓜", "type": "水果類", "min": "25", "max": "30" },
                        { "text": "柚子", "type": "水果類", "min": "23", "max": "29" },
                        { "text": "甜瓜", "type": "蔬菜類", "min": "18", "max": "25" }
                    ]
                }
            },
            //第2至4週客製化預報(最低溫)
            second_week:{

                //圖表內容
                chart:
                {
                    //未來4週內定量降雨機率預報
                    ratio:
                    {
                        //更新時間
                        update_time:"",
                        //系列
                        series:[],
                        //類別
                        categories:[]
                    },
                },
                //表單物件
                input:{
                    //最低溫
                    min_t:{
                        text:"最低溫",
                        value:"",
                        placeholder:"請選擇最低溫",
                        list:[]
                    },
                    //最高溫
                    max_t:{
                        text:"最高溫",
                        value:"",
                        placeholder:"請選擇最高溫",
                        list:[]
                    },
                    //周別
                    week_day:{
                        text:"周別",
                        value:"",
                        placeholder:"請選擇周別",
                        list:[]
                    },
                },
                //相關清單
                list:{
                    //溫度警示日期(溫度事件警示燈號)
                    date_t:[],
                    //最低溫(溫度事件警示燈號)
                    min_t:[],
                    //最高溫(溫度事件警示燈號)
                    max_t:[],
                    //未來4週內定量降雨機率預報
                    ratio:[],
                }, 
                //相關物件 
                obj:{
                    //更新時間(溫度事件警示燈號)
                    update_time:"",
                    //最低溫(溫度事件警示燈號)
                    min_t:{},
                    //最高溫(溫度事件警示燈號)
                    max_t:{},
                }, 
                //相簿
                precp_header:{

                    //檔案清單
                    list:[
                        "lt1.png",
                        "1-50.png",
                        "50-100.png",
                        "100-200.png",
                        "200-300.png",
                        "300up.png",
                    ],
                    //目前選擇
                    select_index:0,
                    //路徑
                    path:""
                } 
            },

            //一周預報
            next_week:{

                //表格內容
                table:"",
                //圖表內容
                chart:
                {
                    //不降雨機率
                    norain_ratio:
                    {
                        //更新時間
                        update_time:"",
                        //時間
                        date:[],
                        //機率(%)
                        pr:[]
                    },
                }
            },

            //農業氣象觀測-第2至4週客製化預報(溫度事件警示燈號)
            apiGetWarningLightInfo: (data) => this.userRequest.get("API/Default/GetWarningLightInfo?station_id=" + this.station_id, data),

            //農業氣象觀測-取得一週預報(表格資料)
            apiGetForecastForTableNextWeek: (data) => this.userRequest.get("API/Default/GetForecastForTableNextWeek?token=" + this.token + "&level=" + this.level, data),
        }
    },
    watch:{

        //作物種類
        "input.type.value"(val) {
            const list = this.input.crop.list.filter(c => c.type === val)
            this.input.crop.value = list.length > 0 ? list[0].text : ""
        },

        //作物
        "input.crop.value"(newCropText) {
            const selectedCrop = this.input.crop.list.find(crop => crop.text === newCropText);

            // 作物沒選就清空
            if (!selectedCrop) {
            this.second_week.input.min_t.value = "";
            this.second_week.input.max_t.value = "";
            return;
            }

            const minVal = Number(selectedCrop.min);
            const maxVal = Number(selectedCrop.max);

            // 確保清單存在且有資料
            const minList = this.second_week.input.min_t.list || [];
            const maxList = this.second_week.input.max_t.list || [];

            if (minList.length === 0 || maxList.length === 0) {
            // 若清單沒資料就直接用作物 min/max
            this.second_week.input.min_t.value = "<" + minVal;
            this.second_week.input.max_t.value = ">" + maxVal;
            return;
            }

            // 將清單字串 "<6" / ">25" 轉成數字
            const minListNums = minList.map(item => Number(item.value.replace("<", "")));
            const maxListNums = maxList.map(item => Number(item.value.replace(">", "")));

            // 計算 final min
            let finalMin;
            if (minVal < Math.min(...minListNums)) finalMin = Math.min(...minListNums);
            else if (minVal > Math.max(...minListNums)) finalMin = Math.max(...minListNums);
            else finalMin = minVal;
            this.second_week.input.min_t.value = "<" + finalMin;

            // 計算 final max
            let finalMax;
            if (maxVal < Math.min(...maxListNums)) finalMax = Math.min(...maxListNums);
            else if (maxVal > Math.max(...maxListNums)) finalMax = Math.max(...maxListNums);
            else finalMax = maxVal;
            this.second_week.input.max_t.value = ">" + finalMax;
        },

        //農業氣象觀測-第2至4週客製化預報(最低溫)
        "second_week.input.min_t.value":function(val){

            if(val != "")
            {
                this.second_week.list.min_t = [];
                var min_keys = Object.keys(this.second_week.obj.min_t[val]);
                for(var i=0 ; i<min_keys.length ; i++)
                {
                    var item = min_keys[i];
                    var value = this.second_week.obj.min_t[val][item];
                    var style = "";
                    switch (value) {
                        case "0":
                        //燈號(綠)-表示事件發生機率低。
                        style = "probability_low";
                        break;
                        case "1":
                        //燈號(黃)-表示事件當日發生機率小，但合併評估前後一日內，有發生機率。
                        style = "probability_medium";
                        break;
                        case "2":
                        //燈號(紅)-表示事件發生機率高。
                        style = "probability_high";
                        break;
                        default:
                        //燈號(灰)- 表示資料尚未更新。
                        style = "probability_null";
                    }
                    this.second_week.list.min_t.push({ 
                        value:style,
                        text:style 
                    });
                }
            }

        },

        //農業氣象觀測-第2至4週客製化預報(最高溫)
        "second_week.input.max_t.value":function(val){

            if(val != "")
            {
                this.second_week.list.max_t = [];
                var max_keys = Object.keys(this.second_week.obj.max_t[val]);
                for(var i=0 ; i<max_keys.length ; i++)
                {
                    var item = max_keys[i];
                    var value = this.second_week.obj.max_t[val][item];
                    var style = "";
                    switch (value) {
                        case "0":
                            //燈號(綠)-表示事件發生機率低。
                            style = "probability_low";
                        break;
                        case "1":
                            //燈號(黃)-表示事件當日發生機率小，但合併評估前後一日內，有發生機率。
                            style = "probability_medium";
                        break;
                        case "2":
                            //燈號(紅)-表示事件發生機率高。
                            style = "probability_high";
                        break;
                        default:
                            //燈號(灰)- 表示資料尚未更新。
                            style = "probability_null";
                    }
                    this.second_week.list.max_t.push({ 
                        value:style,
                        text:style 
                    });
                } 
            }

        },

    },
    mounted() {

        // 抓 hash 部分
        const hash = window.location.hash; 
        // 例子: "#/PwaWeatherSensingInfo?title=%E6%B8%AC%E8%A9%A6"

        // 抓出 ? 後面的參數字串
        const queryString = hash.split("?")[1]; 
        const params = new URLSearchParams(queryString);

        const title = params.get("title");
        const token = params.get("token");
        const level = params.get("level");
        const station_id = params.get("station_id");
        console.log(title);
        console.log(token);
        console.log(level);
        console.log(station_id);

        if(title != null){ this.title = title; }
        if(token != null){ this.token = token; }
        if(level != null){ this.level = level; }
        if(station_id != null){ this.station_id = station_id; }

        //農業氣象觀測-第2至4週客製化預報(溫度事件警示燈號)
        this.apiWarningLightInfo({ });

        //農業氣象觀測-取得一週預報(表格資料)
        this.apiForecastForTableNextWeek({ }); 

        // 預設為 crop.list 的第一筆
        this.input.crop.value = this.input.crop.list[0].text
    },
    methods: {

        //農業氣象觀測-第2至4週客製化預報(溫度事件警示燈號)
        apiWarningLightInfo(data){
        
            this.apiGetWarningLightInfo(data)
            .then((res) => {

                const result = JSON.parse(res.data);
                console.log(result);

                var data =  result.data;
                var min = data.最低溫;
                var max = data.最高溫;
                var min_keys = Object.keys(min);
                var max_keys = Object.keys(max);
                var date_t = [];

                this.second_week.obj.update_time = result.update_time;
                this.second_week.input.min_t.list = [];
                this.second_week.input.min_t.value = "";
                for(var i=0 ; i < min_keys.length ; i++)
                {
                this.second_week.input.min_t.list.push({

                    value:min_keys[i],
                    text:min_keys[i],
                });
                }
                this.second_week.input.min_t.value = min_keys[0];

                this.second_week.input.max_t.list = [];
                this.second_week.input.max_t.value = "";
                for(var j=0 ; j < max_keys.length ; j++)
                {
                this.second_week.input.max_t.list.push({

                    value:max_keys[j],
                    text:max_keys[j],
                });
                }
                this.second_week.input.max_t.value = max_keys[0];

                date_t = min[min_keys[0]];
                date_t = Object.keys(date_t);
                this.second_week.list.date_t = [];
                for(var k=0 ; k < date_t.length ; k++)
                {
                var item = date_t[k];
                item = item.split(" ")[0];
                item = item.split("-")[1] + "/" + item.split("-")[2];
                this.second_week.list.date_t.push({

                    value:item,
                    text:item,
                });
                }

                this.second_week.obj.min_t = min;
                this.second_week.obj.max_t = max;

                this.disableMask();
            })
            .catch((err) => {
                console.log(err);
            }); 

        },

        //農業氣象觀測-取得一周預報(下方表格資料)
        apiForecastForTableNextWeek(data){
        
            this.apiGetForecastForTableNextWeek(data)
            .then((res) => {

                const _this = window.vue._data;

                const result = JSON.parse(res.data);
                console.log(result);
                var norain_ratio = result.norain_ratio;
                this.next_week.chart.norain_ratio.update_time = "";
                this.next_week.chart.norain_ratio.date = [];
                this.next_week.chart.norain_ratio.pr = [];

                for(var j=0 ; j<norain_ratio.length ; j++)
                {
                    var item2 = norain_ratio[j];
                    if(j==0){ this.next_week.chart.norain_ratio.update_time = item2.updateTime; }
                    var strt_date = item2.dataTime.split(" ")[0].split("-")[1] + "/" + item2.dataTime.split(" ")[0].split("-")[2];
                    var end_date = item2.endTime.split(" ")[0].split("-")[1] + "/" + item2.endTime.split(" ")[0].split("-")[2];
                    this.next_week.chart.norain_ratio.date.push(strt_date + "-" + end_date);
                    this.next_week.chart.norain_ratio.pr.push(item2.noRainPR5Day);
                }

                window.ChartNextWeek2 = null;

                window.ThreadTool.Delay(function(){
                    
                    window.setChartNextWeek2("#chart_next_week2",{

                        date:_this.next_week.chart.norain_ratio.date,
                        pr:_this.next_week.chart.norain_ratio.pr
                    });

                },1500);
 
            })
            .catch((err) => {
                console.log(err);
            }); 

        },
    },
    computed: {
        filteredCropList() {
            // 如果還沒選 type，就顯示全部
            if (!this.input.type.value) {
                return this.input.crop.list;
            }

            // 依照 type 過濾
            return this.input.crop.list.filter(
                c => c.type === this.input.type.value
            );
        }
    }
}
</script>
<style scoped>

    /** 作物9日內均價、交易量 */
    #chart_next_week2{
        min-width: 600px;
    }
</style>
